module.exports = __webpack_public_path__ + "img/AptaView.099540d1.png";